export default class PracticeInsurance {
  constructor (options = {}, allDocs = [], fromOneProviderMapping = false, calendarIndexes = []) {
    const showOnAllProviders = !!options.show_on_all_providers
    this.id = options.id || null
    this.provider = options.provider || null
    this.insuranceProviderId = options.insurance_provider_id || null
    this.active = !!options.active
    this.providerIds = showOnAllProviders ? allDocs : (options.doctor_id ? [options.doctor_id] : [])
    this.showOnAllProviders = showOnAllProviders
    this.fromOneProviderMapping = fromOneProviderMapping
    this.calendarIndexes = calendarIndexes
  }
}
